<template>
  <v-container>
    <component :is="getRiparazioniBytewoodComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/riparazioni/bytewood/Index'
  import Insert from './../components/riparazioni/bytewood/Insert'

  export default {
    name: 'RiparazioniBytewood',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getRiparazioniBytewoodComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT('Index')
    }
  }
</script>

<style>
</style>